import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Label } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { PreviewTela } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { Page } from '@4beefopag/4bee-fopag-core/dist/organisms';
import { Col, Row, DatePicker } from 'antd';
import { ContainerTela } from '../../atoms/Apontamento';
import LineGrafic from '../../atoms/LineGrafic';
import { useGetUtilizacaoFolhasPorCompetencia } from '../../../services/repository/utilizacaoRepository';
import TabelaUtilizacao from './TabelaUtilizacao';

const imagem =
  'https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/coop/apontamento_producao/undraw-online-payments-luau-2.png';

function TelaInicial() {
  return (
    <Row>
      <Col
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={{ span: 16, offset: 4 }}
        xxl={{ span: 12, offset: 5 }}
      >
        <PreviewTela
          imagem={imagem}
          title="Realize aqui a pesquisa dos dados referentes à quatidade de acessos"
          subTitle="Ao selecionar nos filtros o que deseja, aparecerá um gráfico exibindo a quantidade de acessos por mês referente ao
        período selecionado."
        />
      </Col>
    </Row>
  );
}

function ReportUtilizacao() {
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [lineGraficWidth, setLineGraficWidth] = useState(0);
  const { loading, data: folhasUsadasPorCompetencia } = useGetUtilizacaoFolhasPorCompetencia(startDate, endDate);

  useEffect(() => {
    const resizePage = () => {
      setLineGraficWidth(document.getElementById('container').offsetWidth - 112);
    };
    resizePage();
    window.addEventListener('resize', resizePage);

    return () => {
      window.removeEventListener('resize', resizePage);
    };
  }, []);

  const afterStartDate = (current) => !startDate || startDate >= current;

  const graficData =
    folhasUsadasPorCompetencia &&
    Object.entries(folhasUsadasPorCompetencia).map(([competencia, folhas]) => ({
      data: moment(competencia).format('MM-YYYY'),
      qtdAcessos: folhas.length,
    }));

  return (
    <Page
      projeto="Cooperativa"
      titulo="Relátorio de Utilização"
      linkManual={process.env.REACT_APP_LINK_MANUAL}
    >
      <Row
        type="flex"
        gutter={[16, 16]}
        style={{ margin: 20 }}
      >
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={6}
          xl={6}
        >
          <Label label="Data inicial">
            <DatePicker.MonthPicker
              allowClear={false}
              placeholder="MM/YYYY"
              format="MM/YYYY"
              picker="month"
              value={startDate}
              onChange={(data) => {
                if (data) {
                  setStartDate(data);
                }
              }}
            />
          </Label>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={6}
          xl={6}
        >
          <Label label="Data Final">
            <DatePicker.MonthPicker
              allowClear={false}
              placeholder="MM/YYYY"
              format="MM/YYYY"
              picker="month"
              value={endDate}
              disabledDate={afterStartDate}
              onChange={(data) => {
                if (data) {
                  setEndDate(data);
                }
              }}
            />
          </Label>
        </Col>
      </Row>

      <ContainerTela>
        {startDate && endDate ? (
          <>
            <div
              style={{
                padding: '28px',
                background: '#fff',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
              }}
            >
              <LineGrafic
                loading={loading}
                xField="data"
                yField="qtdAcessos"
                data={graficData || []}
                width={lineGraficWidth}
                height={200}
                style={{ marginBottom: '20px' }}
              />
            </div>
            <br />
            {folhasUsadasPorCompetencia && <TabelaUtilizacao folhasUsadasPorCompetencia={folhasUsadasPorCompetencia} />}
          </>
        ) : (
          <TelaInicial />
        )}
      </ContainerTela>
    </Page>
  );
}

export default ReportUtilizacao;
